import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function entityNamesReducer(state = initialState.entityNames, action) {
	switch (action.type) {
		case types.ENTITIES_GET_ENTITY_NAMES_SUCCESS:
			return action.entityNames;

		case types.ENTITIES_UPDATE_FIELD_SCALE_TRIAL_STATUS_SUCCESS:
			return { ...state, fieldScaleTrial: action.status };

		case types.ENTITIES_UPDATE_DATA_LAYER_STATUS:
			return { ...state, dataLayer: action.status };

		default:
			return state;
	}
}
